function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31919",
  "data-name": "Path 31919",
  d: "M279.918,100.279A19.869,19.869,0,1,1,260.056,80.42a19.869,19.869,0,0,1,19.862,19.859Z",
  transform: "translate(-240.18 -80.42)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9158",
  "data-name": "Rectangle 9158",
  width: 2.064,
  height: 5.323,
  fill: "none"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "no_comments",
  "data-name": "no comments",
  transform: "translate(-700.001 -211.234)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19968",
  "data-name": "Group 19968",
  transform: "translate(-103.715 -15.063)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19793",
  "data-name": "Group 19793",
  transform: "translate(-129.484 -1456.74)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19952",
  "data-name": "Group 19952",
  transform: "translate(933.2 1683.037)"
}, /*#__PURE__*/React.createElement("g", {
  id: "no-user-found",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19387",
  "data-name": "Group 19387",
  transform: "translate(18.682 20.855)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31912",
  "data-name": "Path 31912",
  d: "M264.9,97.517a.1.1,0,1,1-.032-.072.1.1,0,0,1,.032.072Z",
  transform: "translate(-240.946 -80.951)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31918",
  "data-name": "Path 31918",
  d: "M256.5,97.517a.087.087,0,0,0,.1.1.1.1,0,1,0,0-.194.087.087,0,0,0-.1.1Z",
  transform: "translate(-240.69 -80.951)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_19389",
  "data-name": "Group 19389",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18801",
  "data-name": "Group 18801"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18598",
  "data-name": "Group 18598",
  transform: "translate(54.624)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18578",
  "data-name": "Group 18578",
  opacity: 0.6
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18577",
  "data-name": "Group 18577"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18576",
  "data-name": "Group 18576",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31272",
  "data-name": "Path 31272",
  d: "M1313.839,412.419c.179,1.469-.114,2.712-.655,2.778s-1.125-1.071-1.3-2.539.114-2.712.655-2.778,1.125,1.071,1.3,2.54",
  transform: "translate(-1311.828 -409.877)",
  fill: "#fff"
}))))), /*#__PURE__*/React.createElement("line", {
  id: "Line_2207",
  "data-name": "Line 2207",
  x2: 8.433,
  transform: "translate(3.436 46.63)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2341",
  "data-name": "Line 2341",
  x2: 8.433,
  transform: "translate(81.958 32.096)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2208",
  "data-name": "Line 2208",
  x2: 15.929,
  transform: "translate(0 52.252)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2342",
  "data-name": "Line 2342",
  x2: 15.929,
  transform: "translate(78.522 26.474)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 1.249,
  height: 7.496,
  rx: 0.625,
  transform: "translate(90.078 55.659)",
  fill: "#d8dade"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 1.249,
  height: 7.496,
  rx: 0.625,
  transform: "translate(94.45 58.782) rotate(90)",
  fill: "#d8dade"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_161",
  "data-name": "Union 161",
  d: "M3.123,6.872v-2.5H.625a.625.625,0,0,1,0-1.249h2.5V.626a.625.625,0,1,1,1.249,0v2.5h2.5a.625.625,0,0,1,0,1.249h-2.5v2.5a.625.625,0,1,1-1.249,0Z",
  transform: "translate(8.434 18.977)",
  fill: "#d9d9d9",
  opacity: 0.62
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_19967",
  "data-name": "Group 19967",
  transform: "translate(976.826 1712.798)"
}, /*#__PURE__*/React.createElement("g", {
  id: "chat-dots-fill",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32074",
  "data-name": "Path 32074",
  d: "M32.4,16.427c0,7.83-7.254,14.177-16.2,14.177a18.349,18.349,0,0,1-4.753-.62,29.562,29.562,0,0,1-8.467,2.5.526.526,0,0,1-.553-.734,21.576,21.576,0,0,0,1.559-6.007A13.164,13.164,0,0,1,0,16.427C0,8.6,7.254,2.25,16.2,2.25S32.4,8.6,32.4,16.427Zm-22.278,0A2.025,2.025,0,1,1,8.1,14.4,2.025,2.025,0,0,1,10.126,16.427Zm8.1,0A2.025,2.025,0,1,1,16.2,14.4,2.025,2.025,0,0,1,18.227,16.427ZM24.3,18.452a2.025,2.025,0,1,0-2.025-2.025A2.025,2.025,0,0,0,24.3,18.452Z",
  transform: "translate(0 -2.25)",
  fill: "#fff",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "chat-dots-fill-2",
  "data-name": "chat-dots-fill",
  transform: "translate(2.048 0.683)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32074-2",
  "data-name": "Path 32074",
  d: "M32.4,16.427c0,7.83-7.254,14.177-16.2,14.177a18.349,18.349,0,0,1-4.753-.62,29.562,29.562,0,0,1-8.467,2.5.526.526,0,0,1-.553-.734,21.576,21.576,0,0,0,1.559-6.007A13.164,13.164,0,0,1,0,16.427C0,8.6,7.254,2.25,16.2,2.25S32.4,8.6,32.4,16.427Zm-22.278,0A2.025,2.025,0,1,1,8.1,14.4,2.025,2.025,0,0,1,10.126,16.427Zm8.1,0A2.025,2.025,0,1,1,16.2,14.4,2.025,2.025,0,0,1,18.227,16.427ZM24.3,18.452a2.025,2.025,0,1,0-2.025-2.025A2.025,2.025,0,0,0,24.3,18.452Z",
  transform: "translate(0 -2.25)",
  fill: "#d9d9d9",
  fillRule: "evenodd"
})))), /*#__PURE__*/React.createElement("g", {
  id: "chat",
  transform: "translate(819 249)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32075",
  "data-name": "Path 32075",
  d: "M24.3,22.125a1.824,1.824,0,0,0-.524,1.461,20.014,20.014,0,0,0,.727,3.649A21.537,21.537,0,0,1,19.7,25.606a1.824,1.824,0,0,0-1.295-.135,14.7,14.7,0,0,1-3.812.5c-7.29,0-12.771-5.121-12.771-10.946S7.3,4.074,14.6,4.074,27.366,9.2,27.366,15.021a10.024,10.024,0,0,1-3.062,7.1Zm.9,7.124q.648.128,1.3.235a.474.474,0,0,0,.5-.661q-.243-.573-.445-1.162l-.006-.018a19.079,19.079,0,0,1-.956-4.231,11.848,11.848,0,0,0,3.6-8.392c0-7.054-6.535-12.771-14.6-12.771S0,7.967,0,15.021,6.535,27.791,14.6,27.791a16.529,16.529,0,0,0,4.282-.559A24.943,24.943,0,0,0,25.2,29.249Z",
  transform: "translate(0 -2.25)",
  fill: "#d9d9d9",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  id: "Union_162",
  "data-name": "Union 162",
  d: "M20048,8289.049a1.35,1.35,0,1,1,1.354,1.352A1.351,1.351,0,0,1,20048,8289.049Zm0-3.881v-5.817a1.35,1.35,0,1,1,2.7,0v5.817a1.35,1.35,0,1,1-2.7,0Z",
  transform: "translate(-19215.754 -8021)",
  fill: "#f3994e"
})));
function SvgNoComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94.452,
    height: 63.155,
    viewBox: "0 0 94.452 63.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoComments);
export default __webpack_public_path__ + "static/media/no-comments.cfa2d6b3.svg";
export { ForwardRef as ReactComponent };